





















































































































import { mapActions, mapState } from 'vuex';
import Vue from 'vue';
import Identicon from './Identicon.vue';
import ConnectWalletModal from './ConnectWalletModal.vue';

export interface ConnectWalletButtonData {
  showWallet: Boolean;
}

export default Vue.extend({
  name: 'ConnectWalletButton',
  components: {
    Identicon,
    ConnectWalletModal,
  },
  data: (): ConnectWalletButtonData => ({
    showWallet: false,
  }),
  computed: {
    ...mapState('ethers', ['connected', 'address', 'blance', 'coinName', 'initialized']),
    isGoodToConnect() {
      return this.initialized;
    },
    formatedAddress() {
      if (!this.address) return '';
      return `${this.address.slice(0, 6)}...${this.address.slice(-4)}`;
    },
  },
  methods: {
    ...mapActions('ethers', ['connect']),
    onWalletButtonClick() {
      // TODO: [vuex] unknown action type: connect
      // this.$store.dispatch('connect');
      this.showWallet = true;
    },
  },
});
